import { useTranslate } from '@repo/shared/hooks'
import { isValidMobile } from '@repo/ui/lib'
import { z } from 'zod'

export const useRegisterSchema = () => {
  const { t } = useTranslate()

  const mobileSchema = z.object({
    mobile: z
      .string({
        message: t('loginPage_validation_mobile_numbersOnly'),
      })
      .superRefine((val, ctx) => {
        if (val && !val.startsWith('09')) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('loginPage_validation_mobile_startWith09'),
          })
          return
        }
        if (val && val.length !== 11) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('loginPage_validation_mobile_length'),
          })
          return
        }
        if (!isValidMobile(val)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('loginPage_validation_mobile_numbersOnly'),
          })
        }
      }),
    invitationCode: z.string().nullish(),
  })

  const emailSchema = z.object({
    email: z
      .string({
        message: t('registerPage_validation_email_required'),
      })
      .email({
        message: t('registerPage_validation_email_invalid'),
      }),
    invitationCode: z.string().nullish(),
  })

  return { mobileSchema, emailSchema }
}
